import { APP } from '@/app.config'
import type { OutboxEntry } from '@/domain/outbox'
import type { AttendanceRecord, Meeting, Member, Reason } from '@cadoan/shared'
import Dexie, { type Table } from 'dexie'

/** A stored attendance row carries its compound key so it can be the primary key. */
export type StoredAttendance = AttendanceRecord & { key: string }

export interface KvRow {
  key: string
  value: unknown
}

/**
 * The phone's offline copy. Only the indexes a query uses (pwa_starter rule):
 * everything is loaded into memory at start, so the only index beyond primary
 * keys is the one that finds a deleted meeting's marks.
 */
export class AppDB extends Dexie {
  members!: Table<Member, string>
  meetings!: Table<Meeting, string>
  attendance!: Table<StoredAttendance, string>
  reasons!: Table<Reason, string>
  people!: Table<{ id: string; displayName: string }, string>
  outbox!: Table<OutboxEntry, string>
  kv!: Table<KvRow, string>

  constructor() {
    super(APP.dbName)
    this.version(1).stores({
      members: 'id',
      meetings: 'id',
      attendance: 'key, meetingId',
      reasons: 'id',
      people: 'id',
      outbox: 'key',
      kv: 'key',
    })
  }
}

export const db = new AppDB()
